var $loadMoreNews = $("#loadMore");



function loadNews() {

var $loadingNews = $('#loader'),
    $noMoreNews = $('#noMore'),
    $loadingBay = $('#loadingBay'),
    totalPages, loadUrl, nextPage, nextURL, $elements;

    $body.addClass('working');
    loadUrl = $loadMoreNews.attr('href');
    totalPages = $loadMoreNews.data('total');
    nextPage = $loadMoreNews.data('next');
    $loadingNews.show();
    
  if (nextPage <= totalPages) {

    $loadingBay.load(loadUrl + ' #ajaxHolder', function() {

      $elements = $loadingBay.find('.news-thumbnails__thumbnail');

      $('#ajaxHolder').append($elements);

      nextPage++;

      $loadMoreNews.data('next', nextPage);

      if (nextPage > totalPages) {
          $loadMoreNews.hide();
          $noMoreNews.show();
          $loadingNews.hide();
      }

    //   console.log(nextPage);
    //   console.log(totalPages);

      nextURL = site + '/news/page/' + nextPage;
      $loadMoreNews.attr('href', nextURL);

      if (location.href != loadUrl) {
        history.pushState({}, '', loadUrl);
      }

      $loadingBay.empty();
      $body.removeClass('working');
      $loadingNews.hide();

      $body.rhLoadIn();

      // loadMatrix = [];
      // elements = $('body').find('.loadIn');
      // size = elements.length;
      //
      // sizes();

    });

  }

}

$loadMoreNews.on('click', function(e){
  e.preventDefault();
  loadNews();
});